import { Card, CardContent, Divider, Stack, TextField, Typography, Box } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

const CARD_TITLE = 'Step 1 : Role Details';
const LABEL_ROLE_NAME = 'Role Name';
const LABEL_DESCRIPTION = 'Description';
const SUMMARY_TITLE = 'Summary';
const TOTAL_PERMISSION = 'Total permission';
const MODULES_CONFIGURED = 'Modules configured';
const DEPENDENCY_LOGIC_TEXT =
    'Dependency Logic : Some permissions require others. For example, "Edit" requires "View". Dependencies will be auto-enabled.';

const cardStyles = {
    width: '100%',
};

export type RoleDetailsCardProps = {
    name: string;
    description: string;
    onNameChange: (value: string) => void;
    onDescriptionChange: (value: string) => void;
    totalPermissionCount: number;
    modulesConfiguredCount: number;
    readOnly?: boolean;
};

const RoleDetailsCard = ({
    name,
    description,
    onNameChange,
    onDescriptionChange,
    totalPermissionCount,
    modulesConfiguredCount,
    readOnly = false,
}: RoleDetailsCardProps) => (
    <Card variant="outlined" sx={cardStyles} data-testid="access-center-create-role-details-card">
        <CardContent>
            <Typography variant="h6" component="h2" gutterBottom>
                {CARD_TITLE}
            </Typography>
            <Stack spacing={2} sx={{ mt: 2 }}>
                <Stack spacing={1}>
                    <Typography variant="body2" color="text.secondary">
                        {LABEL_ROLE_NAME}
                    </Typography>
                    <TextField
                        value={name}
                        onChange={(e) => onNameChange(e.target.value)}
                        placeholder="Enter role name"
                        variant="outlined"
                        fullWidth
                        size="small"
                        disabled={readOnly}
                        inputProps={{ 'data-testid': 'access-center-create-role-name-input' }}
                    />
                </Stack>
                <Stack spacing={1}>
                    <Typography variant="body2" color="text.secondary">
                        {LABEL_DESCRIPTION}
                    </Typography>
                    <TextField
                        value={description}
                        onChange={(e) => onDescriptionChange(e.target.value)}
                        placeholder="Enter description"
                        variant="outlined"
                        fullWidth
                        size="small"
                        multiline
                        minRows={2}
                        disabled={readOnly}
                        inputProps={{ 'data-testid': 'access-center-create-role-description-input' }}
                    />
                </Stack>
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" fontWeight={600}>
                    {SUMMARY_TITLE}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {TOTAL_PERMISSION} : {totalPermissionCount}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {MODULES_CONFIGURED} : {modulesConfiguredCount}
                </Typography>
                {!readOnly && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 1,
                            p: 1.5,
                            borderRadius: 1,
                            bgcolor: 'grey.100',
                            border: '1px solid',
                            borderColor: 'grey.300',
                        }}
                        data-testid="access-center-dependency-logic-info"
                    >
                        <InfoIcon sx={{ color: 'grey.600', fontSize: 20, mt: 0.25 }} aria-hidden />
                        <Typography variant="body2" color="text.primary" component="span">
                            {DEPENDENCY_LOGIC_TEXT}
                        </Typography>
                    </Box>
                )}
            </Stack>
        </CardContent>
    </Card>
);

export default RoleDetailsCard;
